import {
  Card,
  CardContent,
  Typography,
  Box
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlined";
import { useTranslation } from "react-i18next";

interface ErrorScreenProps {
  errorMessage?: string;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ errorMessage }) => {
  const { t } = useTranslation();

  return (
    <Box className="bg-theme-bg flex justify-center items-start h-full pt-16"
    >
      <Card sx={{ maxWidth: 400, width: "100%", borderRadius: 3, boxShadow: 3 }} className="fade-up !text-theme-text !bg-theme-surface-2">
        <CardContent sx={{ textAlign: "center", p: 4 }}>
          <ErrorOutlineIcon className="!text-theme-danger" sx={{ fontSize: 48, mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            {t("errorScreen.title")}
          </Typography>
          <Typography variant="body2">
            {errorMessage ?? t("errorScreen.body")}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ErrorScreen;
